import { Timestamp } from "firebase/firestore";

export type CustomerSupportTicket = {
  id: string;
  title: string;
  language: string;
  userId: string;
  userName: string;
  status: TicketStatus;
  sortingPriority: CustomerTicketSortingPriority;
  summary?: string;
  category?: {
    key: string;
    title: string;
  };
  subCategory?: {
    key: string;
    title: string;
  } | null;
  matchingGamesCount: number;
  adminUnreadMessagesCount: number;
  tagType: string;
  updatedAt: Date;
  createdAt: Date;
};

export type CustomerTicketSortingPriority =
  (typeof CustomerSupportTicketSortingPriority)[keyof typeof CustomerSupportTicketSortingPriority];

export const CustomerSupportTicketSortingPriority = {
  Open: 1,
  Processing: 1,
  Answered: 2,
  Closed: 3,
};

export type Category = {
  key: string;
  title: string;
  subCategories?: Array<{ key: string; title: string }>;
};

export enum TicketStatus {
  Open = "Open",
  Processing = "Processing",
  Answered = "Answered",
  Closed = "Closed",
}

export type Message = {
  id: string;
  message: string;
  from: Role;
  admin?: {
    email: string;
  };
  timestamp: Timestamp;
};

export enum Role {
  System = "System",
  Support = "Support",
  User = "User",
}

export enum FilterKeys {
  status = "status",
  language = "language",
  product = "product",
  category = "category.key",
  subCategory = "subCategory.key",
  read = "read",
}

export enum FilterOptions {
  all = "all",
}

export type CategoryAnalytics = {
  category: string;
  thisWeekCount: number;
  lastWeekCount: number;
  weeklyPercentageDifference: number;
};

export type CustomerTicketAnalytics = {
  lastWeekTotalInquiries: number;
  thisWeekTotalInquiries: number;
  weeklyDifferencePercentage: number;
  thisWeekAverageResponseTime: number;
  lastWeekAverageResponseTime: number;
  weeklyResponseTimeDifferencePercentage: number;
  inquiriesByCategory: CategoryAnalytics[];
};
